import { updateNotification } from "./utils/updateNotification";
import { events } from "@planzone/events";
import { pushIf } from "./utils/pushIf";
import { createStateReducer } from "../utils/createStateReducer";
import { initialState } from "./initialState";

const reduceZoneEditionNotificationState = createStateReducer(initialState, {
  [events.editZoneSucceeded]: (state) => ({
    ...state,
    queue: updateNotification(
      {
        key: "editZone",
        flags: ["success"],
        args: { success: "true" },
      },
      state.queue,
    ),
  }),
  [events.editZoneFailed]: (state, { error }) => ({
    ...state,
    queue: updateNotification(
      {
        key: "editZone",
        flags: pushIf({
          invalidName: error.isNameInvalid,
          duplicateZone: error.hasDuplicateName,
          unExpectedError: error.hasUnexpectedError,
        }),
        args: { failure: "true", message: error.message },
      },
      state.queue,
    ),
  }),
});

export { reduceZoneEditionNotificationState };
